import defaultClient from '@src/api/clients/default';

export function fetchBudgetPacing(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/pacing/',
    payload,
  });
}

export function fetchBudgetPacingOverall(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/pacing-overall/',
    payload,
  });
}

export function fetchBudgetPacingSegments(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/pacing-segments/',
    payload,
  });
}

export default {
  fetchBudgetPacing,
  fetchBudgetPacingOverall,
  fetchBudgetPacingSegments,
};
